import { ReactNode } from 'react'
import { Trans } from '@lingui/react/macro'

type ConsentSectionProps = {
  title: string
  children: ReactNode
  required?: boolean
}

export function ConsentSection({ title, children, required }: ConsentSectionProps) {
  return (
    <section className="flex flex-col gap-4 rounded-lg border border-gray-200 bg-white p-5">
      <h3 className="flex items-center text-base font-bold text-gray-900">
        {title}
        {required && <span className="ml-2 text-xs font-medium text-red-600">(<Trans>Required</Trans>)</span>}
      </h3>
      {children}
    </section>
  )
}
